import { render } from "./Skirmishes.vue?vue&type=template&id=1f2e161a"
import script from "./Skirmishes.vue?vue&type=script&lang=js"
export * from "./Skirmishes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__